import React, { PropsWithChildren } from 'react';
import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';
import './index.scss';

interface Props {
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean,
}

export default function BlockDatePickerWrapper({
  children,
  disabled = false,
}: PropsWithChildren<Props>) {
  const iconColor = cssVar(disabled ? 'text-disabled' : 'text-strong');

  return (
    <div className="block-datepicker">
      <span className="icon">
        <Icon iconType="calendar" color={iconColor} />
      </span>
      {children}
    </div>
  );
}
